import { useEffect, useState } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';

interface ProfileData {
  profile?: {
    id: string;
    profileCompletion: number;
  };
  type?: 'teacher' | 'non_educator';
}

export function useProfileCheck() {
  const { isSignedIn, getToken } = useAuth();
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);
  const [profileData, setProfileData] = useState<ProfileData | null>(null);

  useEffect(() => {
    if (!isSignedIn) {
      setIsChecking(false);
      return;
    }

    const checkProfile = async () => {
      try {
        const token = await getToken();
        const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:8787';

        const response = await fetch(`${apiUrl}/api/profiles/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.ok) {
          const data = await response.json() as ProfileData;
          setProfileData(data);

          // Check if profile is incomplete
          if (!data.profile || data.profile.profileCompletion < 100) {
            // Redirect to onboarding
            console.log('[ProfileCheck] Incomplete profile, redirecting to onboarding');
            navigate('/profile/photos');
          }
        } else if (response.status === 404) {
          // No profile exists, redirect to onboarding
          console.log('[ProfileCheck] No profile found, redirecting to onboarding');
          navigate('/profile/photos');
        }
      } catch (error) {
        console.error('[ProfileCheck] Error checking profile:', error);
      } finally {
        setIsChecking(false);
      }
    };

    checkProfile();
  }, [isSignedIn, getToken, navigate]);

  return { isChecking, profileData };
}